// extracted by css-extract-rspack-plugin
export default {"container":"StaleCacheBanner-module__container__Sv1fC"};